/*
 * @Description:
 * @Date: 2020-05-19 17:13:16
 * @LastEditors: wjx
 */

export default {
  name: 'detailRender',
  functional: true,
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  render: (h, ctx) => {
    return ctx.props.render(h, ctx);
  }
};
